import { render, staticRenderFns } from "./PrivateRegistration.vue?vue&type=template&id=52abeca7&"
import script from "./PrivateRegistration.vue?vue&type=script&lang=js&"
export * from "./PrivateRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports